// shop-by-brands.js

// ====== CONFIGURATION ======
// Replace with your actual Storefront Access Token (from your Shopify admin Storefront API settings)
const STOREFRONT_ACCESS_TOKEN = 'f2dc6c56661e7b1175995fbbfe8f241c';

// Replace with your shop domain (do not include https://)
const SHOP_DOMAIN = 'discountwidgets.myshopify.com';

// GraphQL endpoint for the Storefront API (version 2024-10 used here; adjust if needed)
const GRAPHQL_ENDPOINT = `https://${SHOP_DOMAIN}/api/2024-10/graphql.json`;
// =============================

// Wait for the DOM to be fully loaded (with a slight delay to ensure required elements are present)
document.addEventListener("DOMContentLoaded", function() {
  setTimeout(initShopByBrand, 500);
});

// Main initialization function
async function initShopByBrand() {
  const brandsRenderPoint = document.getElementById("brands-render-point");
  const navigationRenderPoint = document.getElementById("navigation-render-point");

  if (!brandsRenderPoint || !navigationRenderPoint) {
    console.error("Missing required DOM elements.");
    return;
  }

  try {
    // Fetch all collections via the Storefront API
    const collections = await fetchAllCollectionsGraphQL();
    console.log("Total Collections Fetched:", collections.length);

    // Filter out any collections that should be excluded based on title patterns
      const filteredCollections = collections.filter(c => {
        const hasProducts = c.products?.edges?.length > 0;
        return !shouldExclude(c) && hasProducts;
      });


    // Sort collections alphabetically by title
    filteredCollections.sort((a, b) => a.title.localeCompare(b.title));

    // Render the alphabet navigation bar
    navigationRenderPoint.innerHTML = "";
    navigationRenderPoint.appendChild(renderBrandAlphabetNavigationBar(filteredCollections));

    // Render the Shop by Brand table
    brandsRenderPoint.innerHTML = "";
    brandsRenderPoint.appendChild(renderShopByBrandMenu(filteredCollections));

  } catch (error) {
    console.error("Error fetching collections:", error);
    brandsRenderPoint.innerHTML = "<p>Error fetching collections.</p>";
  }
}

// Fetch all collections using the Storefront API (cursor-based pagination)
async function fetchAllCollectionsGraphQL() {
  const allCollections = [];
  let hasNextPage = true;
  let cursor = null;

  // GraphQL query to get collections (up to 250 per page)
const query = `
  query getCollections($cursor: String) {
    collections(first: 250, after: $cursor) {
      edges {
        node {
          id
          title
          handle
          products(first: 1) {
            edges {
              node {
                id
              }
            }
          }
        }
        cursor
      }
      pageInfo {
        hasNextPage
      }
    }
  }
`;


  while (hasNextPage) {
    const variables = { cursor: cursor };
    const response = await fetch(GRAPHQL_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN
      },
      body: JSON.stringify({ query, variables })
    });

    if (!response.ok) {
      throw new Error("Network error: " + response.statusText);
    }

    const result = await response.json();
    if (result.errors) {
      throw new Error("GraphQL error: " + JSON.stringify(result.errors));
    }

    const collectionsData = result.data.collections;
    collectionsData.edges.forEach(edge => {
      allCollections.push(edge.node);
    });

    hasNextPage = collectionsData.pageInfo.hasNextPage;
    if (hasNextPage) {
      // Set the cursor to the last edge's cursor
      cursor = collectionsData.edges[collectionsData.edges.length - 1].cursor;
    }
  }

  return allCollections;
}

// Exclude collections based on title patterns (adjust as needed)
function shouldExclude(collection) {
  const title = collection.title.toUpperCase();
  return (
    /^\d{4}-\d{4}/.test(title) ||  // e.g., "1234-5678"
    /^\d.*%/.test(title) ||         // Titles starting with a digit and containing '%'
    /EVENTCODE:/.test(title) ||
    /^EB-/.test(title) ||
    /\bsale\b/i.test(title)||
    />/.test(title) 
  );
}

// Render the alphabet navigation bar (0-9 and A-Z)
function renderBrandAlphabetNavigationBar(collections) {
  const table = document.createElement("table");
  table.className = "Table Table--navigationBar";

  const tbody = document.createElement("tbody");
  const row = document.createElement("tr");

  // Array of letters including "0-9"
  const letters = ["0-9", ...("ABCDEFGHIJKLMNOPQRSTUVWXYZ").split("")];
  letters.forEach(letter => {
    const td = document.createElement("td");
    const a = document.createElement("a");
    a.className = "Link--noWrap";
    a.href = `#brands_${letter}`;
    a.innerText = letter;
    td.appendChild(a);
    row.appendChild(td);
  });

  tbody.appendChild(row);
  table.appendChild(tbody);
  return table;
}

// Render the Shop by Brand table with collections grouped by the first letter of their title
function renderShopByBrandMenu(collections) {
  const table = document.createElement("table");
  table.className = "Table brand__table";

  let currentBrandLetter = "";
  let currentRow = document.createElement("tr");
  let currentRowColumn = 0;

  collections.forEach(collection => {
    const newBrandLetter = collection.title.charAt(0).toUpperCase();
    const displayLetter = isNaN(parseInt(newBrandLetter)) ? newBrandLetter : "0-9";

    if (displayLetter !== currentBrandLetter) {
      // Append the current row if it's not empty
      if (currentRow.childElementCount > 0) {
        table.appendChild(currentRow);
        currentRow = document.createElement("tr");
      }
      currentBrandLetter = displayLetter;
      table.appendChild(createBrandAlphabetRow(currentBrandLetter));
      currentRowColumn = 0;
    }

    // If the current row already has three cells, start a new row
    if (currentRowColumn % 3 === 0 && currentRow.childElementCount > 0) {
      table.appendChild(currentRow);
      currentRow = document.createElement("tr");
    }

    currentRow.appendChild(createBrandCell(collection.title, `/collections/${collection.handle}`));
    currentRowColumn++;
  });

  if (currentRow.childElementCount > 0) {
    table.appendChild(currentRow);
  }
  return table;
}

// Create a header row for a letter section with a "Top" link
function createBrandAlphabetRow(letter) {
  const row = document.createElement("tr");
  row.id = "brands_" + letter;
  row.className = "BrandLetterRow";

  // Cell for the letter header
  const letterCell = document.createElement("td");
  letterCell.colSpan = 1;
  letterCell.className = "top__link";
  const h1 = document.createElement("h1");
  h1.className = "Form__Title Heading u-h1";
  h1.innerText = letter;
  letterCell.appendChild(h1);
  row.appendChild(letterCell);

   // Ensure there are always 3 TDs in each row
  while (row.childElementCount < 3) {
    const emptyCell = document.createElement("td");
    row.appendChild(emptyCell);
  }

  // Add the Top link only if the letter is not "0-9" or "A"
  if (!(letter === "0-9" || letter === "A")) {
    const topLinkCell = document.createElement("td");
    topLinkCell.className = "top__link";
    const topLink = document.createElement("a");
    topLink.href = "#";
    topLink.innerText = "Top";
    topLink.className = "Link--noWrap Link--topLink";
    topLink.onclick = () => window.scrollTo(0, 0);
    topLinkCell.appendChild(topLink);
    row.appendChild(topLinkCell);
  }

  return row;
}


// Create a cell for an individual collection with a clickable link
function createBrandCell(title, url) {
  const cell = document.createElement("td");
  const a = document.createElement("a");
  a.className = "Link Link--primary Link--underlineShort";
  a.href = url;
  a.innerText = title;
  cell.appendChild(a);
  return cell;
}
